<template>
  <div>
    <h3 v-if="labelPosition === 'before'">
      {{ field.name }}
    </h3>
    <p v-html="field.htmlContent" />
    <h3 v-if="labelPosition === 'after'">
      {{ field.name }}
    </h3>
  </div>
</template>

<script setup lang="ts">
import { fieldLabelPosition } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: {
    name: string
    htmlContent: string
  }
}

const props = defineProps<Props>()

const labelPosition = fieldLabelPosition(props.settings, props.field)
</script>
